module.exports = __webpack_public_path__ + "img/logo7.12de4afc.png";